import React from 'react';
import './NoteLegCo.css';




export default function NoteLegCo() {
  return (

    <div className='content mr'>
      <h2>Note Legali</h2>

      <br />

      <h3>Termini Legali</h3>
      <p>Il presente avviso contiene i termini e le condizioni legali che regolano il sito di proprietà di Marco Nitto.
        Accedendo al sito, gli utenti si impegnano ad accettare e concordare di attenersi al rispetto di tutte le condizioni
        contenute in questa dichiarazione.
        La nostra ditta si riserva il diritto di chiedere agli Utenti che non accettino o non intendano rispettare tali termini, di astenersi dall’utilizzo del sito web.
        L’accesso al sito ed ai relativi servizi è destinato esclusivamente ad utilizzo personale.
        La visualizzazione del sito fornisce ai Clienti informazioni sui prodotti proposti insieme alla possibilità di acquisto degli stessi.</p>

      <h3>Proprietà – Copyright</h3>

      <p>
        Il sito ed il suo contenuto è proprietà di Marco Nitto.
        Ciò include documentazione, immagini, caratteri, design, musica, software, codici e format scripts.
        Il materiale contenuto nel sito web è protetto da copyright. Qualsiasi riproduzione, alterazione, trasmissione,
        pubblicazione o ridistribuzione a terzi, per scopi commerciali, è severamente vietata se priva di espresso consenso
        scritto fornito da Marco Nitto. Pertanto si vieta l’utilizzo del contenuto o dei marchi presenti nel sito per ogni
        altro scopo e fine diversi da quelli sopra citati.
      </p>

      <h3>Articoli ed Immagini On-Line</h3>

      <p>Marco Nitto declina ogni responsabilità circa la possibilità che, a causa di una particolare configurazione del computer
        utilizzato dal Cliente o di un suo malfunzionamento, i colori dei prodotti visualizzati sul sito presentino leggere
        differenze rispetto a quelli originali.
        Le immagini contenute sul sito sono di proprietà di Warfit. Ogni utilizzo di tali immagini, non autorizzato da un consenso
        scritto, sarà perseguito a norma di legge.

        {/* Disponibilità degli articoli

           Nell’eventualità in cui gli articoli ordinati non siano disponibili, o se per qualche motivo l’ordine non possa essere
           evaso come da richiesta del Cliente, lo stesso ufficio darà tempestiva comunicazione al Cliente. */}

      </p>

      <h2>TIPOLOGIE DI DATI RACCOLTI</h2>

      <p>Fra i Dati Personali raccolti da questa Applicazione, in modo autonomo o tramite terze parti, ci sono: Cookie,
        Dati di utilizzo, Nome, Email, Cognome, Numero di Telefono, Indirizzo, Nazione, CAP e Città.

        Altri Dati Personali raccolti potrebbero essere indicati in altre sezioni di questa privacy policy o mediante testi
        informativi visualizzati contestualmente alla raccolta dei Dati stessi.
        I Dati Personali possono essere inseriti volontariamente dall’Utente, oppure raccolti in modo automatico durante l’uso
        di questa Applicazione.
        L’eventuale utilizzo di Cookie – o di altri strumenti di tracciamento – da parte di questa Applicazione o dei titolari
        dei servizi terzi utilizzati da questa Applicazione, ove non diversamente precisato, ha la finalità di identificare
        l’Utente e registrare le relative preferenze per finalità strettamente legate all’erogazione del servizio richiesto
        dall’Utente.
        Il mancato conferimento da parte dell’Utente di alcuni Dati Personali potrebbe impedire a questa Applicazione di erogare
        i propri servizi.

        L’Utente si assume la responsabilità dei Dati Personali di terzi pubblicati o condivisi mediante questa
        Applicazione e garantisce di avere il diritto di comunicarli o diffonderli, liberando il Titolare da qualsiasi
        responsabilità verso terzi.</p>



      <h2>MODALITÀ E LUOGO DEL TRATTAMENTO DEI DATI RACCOLTI</h2>
      <h3>MODALITÀ DI TRATTAMENTO</h3>

      <p>Il Titolare tratta i Dati Personali degli Utenti adottando le opportune misure di sicurezza volte ad impedire
        l’accesso, la divulgazione, la modifica o la distruzione non autorizzate dei Dati Personali.
        Il trattamento viene effettuato mediante strumenti informatici e/o telematici, con modalità organizzative e con
        logiche strettamente correlate alle finalità indicate. Oltre al Titolare, in alcuni casi, potrebbero avere accesso
        ai Dati categorie di incaricati coinvolti nell’ organizzazione del sito (personale amministrativo, commerciale,
        marketing, legali, amministratori di sistema) ovvero soggetti esterni (come fornitori di servizi tecnici terzi,
        corrieri postali, hosting provider, società informatiche, agenzie di comunicazione) nominati anche, se necessario,
        Responsabili del Trattamento da parte del Titolare. L’elenco aggiornato dei Responsabili potrà sempre essere richiesto
        al Titolare del Trattamento.</p>


      <h3>LUOGO</h3>

      <p>I Dati sono trattati presso le sedi operative del Titolare ed in ogni altro luogo in cui le parti coinvolte nel trattamento
        siano localizzate. Per ulteriori informazioni, contatta il Titolare.</p>

      <h3>TEMPI</h3>

      <p>I Dati sono trattati per il tempo necessario allo svolgimento del servizio richiesto dall’Utente, o richiesto dalle finalità
        descritte in questo documento, e l’Utente può sempre chiedere l’interruzione del Trattamento o la cancellazione dei Dati.</p>

      <h2>FINALITÀ DEL TRATTAMENTO DEI DATI RACCOLTI</h2>

      <p>I Dati dell’Utente sono raccolti per consentire al Titolare di fornire i propri servizi, così come per le seguenti finalità:
        Statistica, Contattare l’Utente, Registrazione ed autenticazione e Interazione con social network e piattaforme esterne.
        Le tipologie di Dati Personali utilizzati per ciascuna finalità sono indicati nelle sezioni specifiche di questo documento.
      </p>

      <h2>DETTAGLI SUL TRATTAMENTO DEI DATI PERSONALI</h2>

      <p>I Dati Personali sono raccolti per le seguenti finalità ed utilizzando i seguenti servizi:</p>

      <ul>

        <li>
          <h3>CONTATTARE L’UTENTE</h3>
          <h4>MODULO DI CONTATTO (QUESTA APPLICAZIONE)</h4>
          <p>L’Utente, compilando con i propri Dati il modulo di contatto, acconsente al loro utilizzo per
            rispondere alle richieste di informazioni, di preventivo, o di qualunque altra natura indicata
            dall’intestazione del modulo. Dati personali raccolti: Email e Nome.</p>
        </li>

        <li>
          <h3>INTERAZIONE CON SOCIAL NETWORK E PIATTAFORME ESTERNE</h3>
          <p>Questi servizi permettono di effettuare interazioni con i social network, o con altre piattaforme
            esterne, direttamente dalle pagine di questa Applicazione.
            Le interazioni e le informazioni acquisite da questa Applicazione sono in ogni caso soggette alle
            impostazioni privacy dell’Utente relative ad ogni social network.
            Nel caso in cui sia installato un servizio di interazione con i social network, è possibile
            che, anche nel caso gli Utenti non utilizzino il servizio, lo stesso raccolga dati di traffico
            relativi alle pagine in cui è installato.

          </p>

          <h6>PULSANTE MI PIACE E WIDGET SOCIALI DI FACEBOOK (FACEBOOK, INC.)</h6>

          <p>Il pulsante “Mi Piace” e i widget sociali di Facebook sono servizi di interazione con il social network Facebook, forniti da Facebook, Inc.
            Dati personali raccolti: Cookie e Dati di utilizzo.
            Luogo del trattamento : USA – Privacy Policy</p>

        </li>

        <li>
          <h3>REGISTRAZIONE ED AUTENTICAZIONE</h3>
          <p>Con la registrazione o l’autenticazione l’Utente consente all’Applicazione di indentificarlo e di dargli
            accesso a servizi dedicati.
            A seconda di quanto indicato di seguito, i servizi di registrazione e di autenticazione potrebbero essere
            forniti con l’ausilio di terze parti.
            Qualora questo avvenga, questa applicazione potrà accedere ad alcuni Dati conservati dal servizio terzo
            usato per la registrazione o l’identificazione.</p>

          <h6>REGISTRAZIONE DIRETTA (QUESTA APPLICAZIONE)</h6>

          <p>L’Utente si registra compilando il modulo di registrazione e fornendo direttamente a questa Applicazione
            i propri Dati Personali.
            Dati personali raccolti: CAP, Città, Cognome, Email, Indirizzo, Nazione, Nome e Numero di Telefono.</p>
        </li>
      </ul>

      <h2>DIFESA IN GIUDIZIO</h2>

      <p>I Dati Personali dell’Utente possono essere utilizzati per la difesa da parte del Titolare
        in giudizio o nelle fasi propedeutiche alla sua eventuale instaurazione, da abusi nell’utilizzo della
        stessa o dei servizi connessi da parte dell’Utente.
        L’Utente dichiara di essere consapevole che il Titolare potrebbe essere richiesto di rivelare i Dati su
        richiesta delle pubbliche autorità.</p>

      <h2>INFORMATIVE SPECIFICHE</h2>

      <p>Su richiesta dell’Utente, in aggiunta alle informazioni contenute in questa privacy policy,
        questa Applicazione potrebbe fornire all’Utente delle informative aggiuntive e contestuali riguardanti
        servizi specifici, o la raccolta ed il trattamento di Dati Personali.
      </p>

      <h2>LOG DI SISTEMA E MANUTENZIONE</h2>

      <p>Per necessità legate al funzionamento ed alla manutenzione, questa Applicazione e gli eventuali
        servizi terzi da essa utilizzati potrebbero raccogliere Log di sistema, ossia file che registrano le
        interazioni e che possono contenere anche Dati Personali, quali l’indirizzo IP Utente.</p>

      <h2>
        INFORMAZIONI NON CONTENUTE IN QUESTA POLICY
      </h2>

      <p>Maggiori informazioni in relazione al trattamento dei Dati Personali potranno essere richieste in qualsiasi momento al Titolare del Trattamento utilizzando le informazioni di contatto.</p>

      <h2>ESERCIZIO DEI DIRITTI DA PARTE DEGLI UTENTI
      </h2>

      <p>I soggetti cui si riferiscono i Dati Personali hanno il diritto in qualunque momento di ottenere la conferma dell’esistenza o meno degli stessi presso il Titolare del Trattamento, di conoscerne il contenuto e l’origine, di verificarne l’esattezza o chiederne l’integrazione, la cancellazione, l’aggiornamento, la rettifica, la trasformazione in forma anonima o il blocco dei Dati Personali trattati in violazione di legge, nonché di opporsi in ogni caso, per motivi legittimi, al loro trattamento. Le richieste vanno rivolte al Titolare del Trattamento.</p>

      <p>Questa Applicazione non supporta le richieste “Do Not Track”. Per conoscere se gli eventuali servizi di terze parti utilizzati le supportano, consulta le loro privacy policy.</p>

      <h2>RESPONSABILE DEL TRATTAMENTO (O RESPONSABILE)
      </h2>

        <p>La persona fisica, giuridica, la pubblica amministrazione e qualsiasi altro ente, associazione od organismo preposti dal Titolare al trattamento dei Dati Personali, secondo quanto predisposto dalla presente privacy policy.</p>

      <h4>TITOLARE DEL TRATTAMENTO (O TITOLARE)
      </h4>

            <p>La persona fisica, giuridica, la pubblica amministrazione e qualsiasi altro ente, associazione od organismo cui competono, anche unitamente ad altro titolare, le decisioni in ordine alle finalità, alle modalità del trattamento di dati personali ed agli strumenti utilizzati, ivi compreso il profilo della sicurezza, in relazione al funzionamento e alla fruizione di questa Applicazione. Il Titolare del Trattamento, salvo quanto diversamente specificato, è il proprietario di questa Applicazione.</p>

        <h4>QUESTA APPLICAZIONE
        </h4>

            <p>Lo strumento hardware o software mediante il quale sono raccolti i Dati Personali degli Utenti.</p>

          <h4>COOKIE</h4>

            <p>Piccola porzione di dati conservata all’interno del dispositivo dell’Utente.﻿</p>

          <h2>Avviso sul diritto di recesso</h2>
          <p><b>In conformità all’Art. 59 del Codice del Consumo (D.Lgs. 206/2005), il diritto di recesso di 14 giorni non è applicabile per gli acquisti di contenuti digitali forniti tramite download. Una volta avviato il download, non è possibile restituire il prodotto, in quanto si tratta di beni non materiali che, per loro natura, non possono essere resi.
          </b></p>

    </div>

  );
}
